import { render, staticRenderFns } from "./RootsAndSquares.vue?vue&type=template&id=068f9d92&lang=pug&"
import script from "./RootsAndSquares.vue?vue&type=script&lang=js&"
export * from "./RootsAndSquares.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports